import { render, staticRenderFns } from "./Section3.vue?vue&type=template&id=07796de0&scoped=true&"
import script from "./Section3.vue?vue&type=script&lang=js&"
export * from "./Section3.vue?vue&type=script&lang=js&"
import style0 from "./Section3.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Section3.vue?vue&type=style&index=1&id=07796de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07796de0",
  null
  
)

export default component.exports